export default __webpack_public_path__ + "content/f36638c2135b71e5a623dca52b611173.ttf";